import { Navigate, Outlet, useLocation } from 'react-router-dom';

const ProtectedRoute = () => {
  const userData = localStorage.getItem('userID');

  const location = useLocation();

  if (!userData) {
    return <Navigate to="/login" state={{ from: location.pathname }} />;
  }

  return (
    <>
      <Outlet />
    </>
  );
};

export default ProtectedRoute;
